import React from 'react'

const UserIcon21x20pxSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M1.66715 20.5676C1.66715 20.5676 0.000488281 20.5676 0.000488281 18.8604C0.000488281 17.1531 1.66715 12.0314 10.0005 12.0314C18.3338 12.0314 20.0005 17.1531 20.0005 18.8604C20.0005 20.5676 18.3338 20.5676 18.3338 20.5676H1.66715ZM10.0005 10.3242C11.3266 10.3242 12.5983 9.78459 13.536 8.82409C14.4737 7.86358 15.0005 6.56086 15.0005 5.2025C15.0005 3.84415 14.4737 2.54142 13.536 1.58092C12.5983 0.620416 11.3266 0.0808105 10.0005 0.0808105C8.67441 0.0808105 7.40264 0.620416 6.46495 1.58092C5.52727 2.54142 5.00049 3.84415 5.00049 5.2025C5.00049 6.56086 5.52727 7.86358 6.46495 8.82409C7.40264 9.78459 8.67441 10.3242 10.0005 10.3242Z" fill="#3B82F6" />
        </svg>
    )
}

export default UserIcon21x20pxSvg